import { Box } from '@material-ui/core';
import { CardAssetDetails, DefaultAssetDetails } from '@nemuru-eng/js-api-client';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Text } from '@/components/shared/components/Text';

interface ConsumerLoanDetailsDefaultFormProps extends FormGridOptions {
  assetDetails: DefaultAssetDetails | CardAssetDetails;
}

export const ConsumerLoanDetailsDefaultForm = ({
  assetDetails,
  fieldVariant,
  fullWidth,
}: ConsumerLoanDetailsDefaultFormProps) => {
  return (
    <Box pt={2}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <TextFormField name={'type'} label={'TYPE'} value={<Text tId={assetDetails.type} />} />
        <TextFormField name={'description'} label={'DESCRIPTION'} value={assetDetails.description} />
      </FormGridContainer>
    </Box>
  );
};
